import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';
import { Appointment } from 'src/models';
import { UseCreateAppointmentPayload } from './useCreateAppointment';
import { useAppointmentListClient } from './useGetAppointmentList';
import { useAppointmentDetailsClient } from './useGetAppointmentDetails';

export const useUpdateAppointment = () => {
  const { invalidate } = useAppointmentListClient();
  const { invalidate: invalidateAppointmentDetails } =
    useAppointmentDetailsClient();
  return useMutation({
    mutationKey: ['updateAppointment'],
    mutationFn: async (
      payload: {
        appt_uuid: Appointment['appt_uuid'];
      } & UseCreateAppointmentPayload
    ) => {
      const { appt_uuid: _appt_uuid, ...rest } = payload;
      const response = await api.put(
        `/edit_appointment/${payload.appt_uuid}`,
        rest
      );
      return response.data;
    },
    onSuccess: (_, { appt_uuid }) => {
      invalidate();
      invalidateAppointmentDetails({ appt_uuid });
    },
  });
};
